import { objectHasProperty } from './helpers';

type PathValue<
  Obj,
  Path extends string,
> = Path extends `${infer Key}.${infer Rest}`
  ? Key extends keyof Obj
    ? PathValue<Obj[Key], Rest>
    : undefined
  : Path extends keyof Obj
    ? Obj[Path]
    : undefined;

export const getValueByPath = <Obj extends object, Path extends string>(
  obj: Obj,
  path: Path
): PathValue<Obj, Path> => {
  return path.split('.').reduce<unknown>((current, key) => {
    if (!current) return;
    if (typeof current !== 'object') return;
    if (!objectHasProperty(current, key)) return;

    return (current as Record<string, unknown>)[key];
  }, obj) as PathValue<Obj, Path>;
};
